import { FC } from 'react';

import { folderContentIcons } from 'modules/dashboard/constants/foldersContentType';
import TableRow from 'modules/_shared/Table/components/TableRow';
import { RowCell } from 'modules/_shared/Table/types/RowCell';

import { AnalyticsRow } from '../utils/formatEventRow';

type CustomLandingAnalyticsTableRowProps = {
  row: AnalyticsRow;
};

const CustomLandingAnalyticsTableRow: FC<
  CustomLandingAnalyticsTableRowProps
> = ({ row }) => {
  const iconMap = folderContentIcons as Record<string, string>;
  const contentIcon = row.contentType ? iconMap[row.contentType] : '';

  const cells: RowCell[] = [
    {
      key: `partner-${row.id}`,
      className: 'w-150px',
      content: (
        <div className="user-card">
          <div className="user-info">
            <span className="text-primary">{row.partnerLabel}</span>
            {row.partnerEmail ? (
              <span className="sub-text">{row.partnerEmail}</span>
            ) : null}
          </div>
        </div>
      ),
    },
    {
      key: `action-${row.id}`,
      className: 'w-150px',
      content: row.actionLabel,
    },
    {
      key: `section-${row.id}`,
      className: 'w-150px',
      content: row.sectionTitle,
      hideOnMobile: true,
    },
    {
      key: `folder-${row.id}`,
      className: 'w-150px',
      content: row.folderTitle,
      hideOnMobile: true,
    },
    {
      key: `content-${row.id}`,
      className: 'w-150px',
      content: contentIcon ? (
        <span className="d-inline-flex align-items-center gap-1">
          <em className={`icon ${contentIcon} mr-1`} />
          {row.contentTitle}
        </span>
      ) : (
        <span>{row.contentTitle}</span>
      ),
      hideOnMobile: true,
    },
    {
      key: `datetime-${row.id}`,
      className: 'w-100px',
      content: row.dateTime,
      textPosition: 'right',
    },
    {
      key: `device-${row.id}`,
      className: 'w-100px',
      content: row.clientDevice,
      hideOnMobile: true,
    },
    {
      key: `geo-${row.id}`,
      className: 'w-150px',
      content: row.clientLocation,
      hideOnMobile: true,
    },
  ];

  return <TableRow cells={cells} />;
};

export default CustomLandingAnalyticsTableRow;
